import { Card } from "../common/Card";
import { FaChartLine } from "react-icons/fa";
import SummaryCardShimmer from "../../common/reportDashBShimmer/SummaryCardShimmer";
import { ErrorRetry } from "../../common/ErrorRetry";
import { WalletSectionError } from "./WalletSectionError";

export function WalletAgentAnalyticsSection({
  analyticsState,
  topHoldersState,
  agentWalletCards,
  topHolders,
}) {
  return (
    <div>
      <span className="mb-4 text-[#1A1A1A] text-xl">Agent Wallet Analytics</span>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-6">
        {analyticsState.loading ? (
          <SummaryCardShimmer />
        ) : analyticsState.error ? (
          <div className="col-span-full">
            <ErrorRetry
              message={analyticsState.message}
              onRetry={analyticsState.onRetry}
            />
          </div>
        ) : agentWalletCards.length > 0 ? (
          agentWalletCards.map((card, idx) => (
            <Card
              key={idx}
              className="p-6 bg-white rounded-lg shadow-sm border border-gray-100"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-[#6B7280] text-lg">{card.title}</span>
              </div>
              <div className="space-y-2">
                <div className="text-2xl text-[#1A1A1A]">{card.value}</div>
                {card.subtitle && (
                  <div className="text-sm text-[#6B7280]">{card.subtitle}</div>
                )}
                <div
                  className={`flex items-center gap-1 text-xs ${card.trendColor}`}
                >
                  <FaChartLine className="w-3 h-3" />
                  <span>{card.trend}</span>
                </div>
              </div>
            </Card>
          ))
        ) : (
          <div className="col-span-full flex justify-center items-center h-40 text-gray-400 text-lg">
            No summary data available
          </div>
        )}

        <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
          <div className="flex items-center justify-between mb-4">
            <span className="text-[#6B7280] text-lg">Top 5 Agents</span>
            <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
              <h5 className="text-blue-600">₦</h5>
            </div>
          </div>
          <div className="space-y-3">
            {topHoldersState.loading ? (
              [...Array(5)].map((_, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between animate-pulse"
                >
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-gray-200" />
                    <div className="h-4 w-24 bg-gray-200 rounded" />
                  </div>
                  <div className="h-4 w-12 bg-gray-200 rounded" />
                </div>
              ))
            ) : topHoldersState.error ? (
              <WalletSectionError
                message={topHoldersState.message}
                onRetry={topHoldersState.onRetry}
              />
            ) : topHolders.length > 0 ? (
              topHolders.map((agent, index) => (
                <div key={index} className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-[#1E61DC]/10 flex items-center justify-center text-xs text-[#1E61DC] font-semibold">
                      {index + 1}
                    </div>
                    <span className="text-sm text-[#1A1A1A] truncate max-w-[120px]">
                      {agent.entity}
                    </span>
                  </div>
                  <span className="text-sm text-[#1E61DC] font-medium">
                    ₦{(agent.approximateBalance / 1000).toFixed(0)}k
                  </span>
                </div>
              ))
            ) : (
              <div className="text-center text-gray-400 py-8">
                No agents data available
              </div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
